var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "loading-wrapper", class: { "is-loading": _vm.isLoading } },
    [
      _vm.useDeactivatedSwitch
        ? _c("div", { staticClass: "blocks-switch" }, [
            _c("span", { staticClass: "label" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("filter_show_all")) +
                  "\n            "
              ),
              _c("label", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.showDeactivatedOnly,
                      expression: "showDeactivatedOnly",
                    },
                  ],
                  attrs: { type: "checkbox", value: "1" },
                  domProps: {
                    checked: Array.isArray(_vm.showDeactivatedOnly)
                      ? _vm._i(_vm.showDeactivatedOnly, "1") > -1
                      : _vm.showDeactivatedOnly,
                  },
                  on: {
                    change: [
                      function ($event) {
                        var $$a = _vm.showDeactivatedOnly,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "1",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_vm.showDeactivatedOnly = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.showDeactivatedOnly = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.showDeactivatedOnly = $$c
                        }
                      },
                      _vm.onChangeShowDeactivatedOnly,
                    ],
                  },
                }),
                _vm._v(" "),
                _c("span"),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.id + " " + _vm.id + "--overview" },
        [
          _vm.rows.length === 0
            ? [
                _c("div", { class: _vm.id + "--overview__empty-item" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.emptyMessage) +
                      "\n            "
                  ),
                ]),
              ]
            : _vm._l(_vm.rows, function (row, index) {
                return [
                  _c(
                    "div",
                    { class: _vm.id + "--overview__item" },
                    [_vm._t("block", null, { row: row })],
                    2
                  ),
                ]
              }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.isLoading
        ? _c("div", { staticClass: "loading-message" }, [
            _vm._v(_vm._s(_vm.$t("results_loading"))),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }